<script>
  export let style
</script>

<style>
  :global(._2aZyM) {
    display: flex;
    align-items: center;
  }
</style>

<div class="_2aZyM" {style}>
  <slot />
</div>
